import { ModuleTypeConstants } from '../types/ModuleTypeConstants';
import Dictionary from '@/types/Dictionary';

/**
 * Removes the namespace from the getters, mutations, and actions of a module type constants object.
 * @param namespace namespace that should be removed
 * @param type the type that should be transformed
 */
export default function removeNamespace<T extends ModuleTypeConstants>(namespace: string, type: T): T {
    return {
        ...type,
        getters: removeNamespaceFromSub(namespace, type.getters),
        mutations: removeNamespaceFromSub(namespace, type.mutations),
        actions: removeNamespaceFromSub(namespace, type.actions),
    };
}

function removeNamespaceFromSub(namespace: string, sub: Dictionary<string>): Dictionary<string> {
    const namespacePrefix = `${namespace}/`;
    const withoutNamespace: Dictionary<string> = {};
    Object.keys(sub).forEach((key) => {
        withoutNamespace[key] = sub[key].replace(namespacePrefix, '');
    });
    return withoutNamespace;
}
